import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "SuggestionMatches" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "Suggestion",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onSuggestionClick && _ctx.onSuggestionClick(...args))),
    tabindex: "-1",
    ref: "suggestionRef",
    onKeydown: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onKeyDown && _ctx.onKeyDown(...args)))
  }, [
    _cache[2] || (_cache[2] = _createElementVNode("i", { class: "lnr-magnifier SuggestionIcon" }, null, -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.completeSuggestionMatch, (match) => {
        return (_openBlock(), _createElementBlock("span", {
          class: _normalizeClass(match.class)
        }, _toDisplayString(match.text), 3 /* TEXT, CLASS */))
      }), 256 /* UNKEYED_FRAGMENT */))
    ])
  ], 544 /* NEED_HYDRATION, NEED_PATCH */))
}